import React, { useContext } from "react";
import axios from "axios";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Global from "../../util/Global";
import { AlertContext } from "../../util/Alerter";
import { LoaderComponent } from "../../util/Loader";
import { InputAdornment, TextField } from "@mui/material";
import ImageUploader from "../ImageUploader";
import DescriptionIcon from '@mui/icons-material/Description';
import { useNavigate } from "react-router-dom";
import SubtitlesIcon from '@mui/icons-material/Subtitles';



export default function NewsEditComponent({ newsData }) {
    const { t } = useTranslation();
    const navigate = useNavigate()

    const { showAlert } = useContext(AlertContext)
    const [isLoading, setisloading] = useState(true)
    const maxImages = 1





    const [title, settitle] = useState("");
    const [description, setDescription] = useState("");
    const [images, setImages] = useState([]);


    const [errors, setErrors] = useState({
        title: false,
        description: false,
        images: false,
    });


    const ACTUALITY_NEW_URL = Global.backend + "/index.php/api/actualite/new";
    const ACTUALITY_UPDATE_URL = Global.backend + "/index.php/api/actualite/edit";



    useEffect(() => {
        checkProvidedProduct()
        setisloading(false)
    }, [])


    // check if we already passed product details
    const checkProvidedProduct = () => {
        if (!newsData) {
            return
        }



        settitle(newsData.titre);
        setDescription(newsData.description);
        setImages([{ imageURL: newsData.image }]);
    }



    const onImageDelete = async (imageId) => {
        return
        const DELETE_IMAGE_URL = Global.backend + "/index.php/produit/deleteImage";

        try {
            await axios.post(DELETE_IMAGE_URL, { imageId });
        } catch (err) {
            showAlert("error", t("request.errorDeleteImage"));
            throw ""
        }
    }

    const checkInputs = () => {
        const errors = {
            title: title.length < 4,
            description: description.length < 5,
            images: images.length === 0,
        };

        setErrors(errors)



        const hasErrors = Object.values(errors).some(error => error)

        if (hasErrors) {
            let errorMessage = t("news.verifyNewsDetails")

            showAlert("error", errorMessage)
        }


        return !hasErrors
    }



    function onSubmit() {
        if (!checkInputs()) {
            return
        }

        setisloading(true);

        const formData = new FormData();





        formData.append('titre', title);
        formData.append('description', description);





        if (!newsData) {
            // add news
            formData.append(`assets`, images[0].file);


            axios
                .post(ACTUALITY_NEW_URL, formData)
                .then((response) => {
                    showAlert("success", t("request.successAddNews"))
                    navigate("/dashboard/admin/adminactualitelist")
                }).catch((err) => {
                    showAlert("error", t("request.errorAddNews"))
                })
                .finally(() => {
                    setisloading(false);
                });
        } else {
            // update news
            formData.append("id", newsData.id);




            if (!images[0].imageURL) {
                // only add local images and not already uploaded images
                formData.append(`assets`, images[0].file);
            }



            axios
                .post(ACTUALITY_UPDATE_URL, formData)
                .then(() => {
                    showAlert("success", t("request.successUpdateAd"))
                }).catch((err) => {
                    showAlert("error", t("request.errorUpdateAd"))
                })
                .finally(() => {
                    setisloading(false);
                });
        }
    }


    return (
        <LoaderComponent isLoading={isLoading}>

            <div className="container-fluid">

                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-body">
                                <div
                                    id="addproduct-nav-pills-wizard"
                                    className="twitter-bs-wizard"
                                >
                                    <div className=" twitter-bs-wizard-tab-content">



                                        <div className="tab-pane" id="basic-info">
                                            <h4 className="card-title">{t("news.details")}</h4>
                                            <p className="card-title-desc"></p>


                                            <div className="row mb-3">
                                                <div className="col-12">
                                                    <TextField value={title} error={errors.title} fullWidth variant="outlined" type="text" label={t("news.title")} onChange={(e) => settitle(e.target.value)}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <SubtitlesIcon />
                                                                </InputAdornment>
                                                            )
                                                        }} />
                                                </div>
                                            </div>





                                            <div className="mb-3">
                                                <TextField
                                                    error={errors.description}
                                                    fullWidth
                                                    multiline
                                                    rows={6}
                                                    variant="outlined"
                                                    label={t("news.description")}
                                                    value={description}
                                                    onChange={(e) => setDescription(e.target.value)}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <DescriptionIcon />
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                            </div>



                                            <ImageUploader error={errors.images} images={images} maxImages={maxImages} setImages={setImages} onImageDelete={onImageDelete} setisLoading={setisloading} />
                                        </div>









                                        <div
                                            className="tab-pane"
                                            id="metadata"
                                            style={{ cursor: "pointer" }}
                                        >
                                            <ul className="pager wizard twitter-bs-wizard-pager-link">
                                                <li
                                                    className="float-end"
                                                    style={{ cursor: "pointer" }}
                                                >

                                                    <a onClick={() => { onSubmit() }}>
                                                        {newsData ? t("news.saveNews") : t("news.addNews")}
                                                        <i className="mdi mdi-arrow-right ml-1"></i>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </LoaderComponent>
    )

};
